import backgroundAudioService from '../../services/BackgroundAudioService';
import globalsService from '../../services/GlobalsService';
import studentHighlightsService from '../../services/StudentHighlightsService';
import uiService from '../../services/UIService';
import utilService from '../../services/UtilService';
import sessionReader from '../../store/readHelpers/SessionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';
import uiReader from '../../store/readHelpers/uiReader';

const headerNotificationsSelector = {
    selectAssetRoot() {
        return globalsService.getAssetRoot();
    },

    selectCandidateInfoString() {
        return utilService.getCandidateInfoString(sessionReader.getUserInfo(),
            sessionReader.getCandidateId());
    },

    selectIsChatEnabled() {
        return settingsReader.isChatEnabled();
    },

    selectIsNoteTakingAndHighlightingEnabled() {
        return studentHighlightsService.isNoteTakingAndHighlightingEnabled();
    },

    selectShowEndTimePostPrimaryEndTime() {
        return sessionReader.showEndTimePostPrimaryEndTime();
    },

    selectShowMessagesButton(ui) {
        return sessionReader.isContextExam() && !!ui.variables.header__showMessagesButton;
    },

    selectShowRecordingNotification(remoteOralExam) {
        return uiService.showRecordingNotification(remoteOralExam);
    },

    selectShowTimeRemaining(hideTimeRemaining) {
        return (sessionReader.isContextExam() || sessionReader.isContextPreview() || sessionReader.isContextPreviewAudioScript())
            && !sessionReader.isRemoteOralExam()
            && !sessionReader.isContextReadinessCheck()
            && !uiReader.isTimeRemainingHidden()
            && !hideTimeRemaining
            && !sessionReader.isDemoExam()
            && !backgroundAudioService.isBackgroundAudioControllable();
    },

    selectOneMinuteRemaining(timeRemaining) {
        return timeRemaining > -1 && timeRemaining < 60000;
    },

    selectShowOwnPreviewSwitcher() {
        return sessionReader.isContextPreview() && !uiService.isInIframe() && settingsReader.isOneWayNavigationEnabled();
    },

    selectLogoPath(ui) {
        return ui.variables[`header__logoPath_${ui.contrastOption}`] || ui.variables.header__logoPath;
    },

    selectProps(state, ownProps) {
        const {
            api,
            assessment,
            delivering,
            settings,
            time,
            ui,
        } = state;

        const { hideTimeRemaining } = ownProps;

        return {
            assessment,
            assetRoot: this.selectAssetRoot(),
            candidateInfoString: this.selectCandidateInfoString(),
            connectionStatus: api.connectionStatus,
            finalMinutesMode: time.finalMinutesMode,
            hasDelivered: !!delivering.hasDelivered,
            isChatEnabled: this.selectIsChatEnabled(),
            isNoteTakingAndHighlightingEnabled: this.selectIsNoteTakingAndHighlightingEnabled(),
            logoPath: this.selectLogoPath(ui),
            offlineMode: !!api.offlineMode,
            oneMinuteRemaining: this.selectOneMinuteRemaining(time.timeRemaining),
            pauseTime: time.pauseTime,
            remainingTimePrimaryEndTime: time.remainingTimePrimaryEndTime,
            settings,
            showEndTimePostPrimaryEndTime: this.selectShowEndTimePostPrimaryEndTime(),
            showMessagesButton: this.selectShowMessagesButton(ui),
            showTimeRemaining: this.selectShowTimeRemaining(hideTimeRemaining),
            showBackgroundAudioControlButton: uiService.showBackgroundAudioControlButton(),
            showOwnPreviewSwitcher: this.selectShowOwnPreviewSwitcher(),
            timeRemaining: time.timeRemaining,
            ui,
            showLivestreamStatus: sessionReader.supportsLivestream(),
        };
    },
};

export default headerNotificationsSelector;
